import { useAppDispatch, useAppSelector } from '../../../../../lib/store';
import { setNoteSortBy } from '../../../state/annotationSlice';
import { selectNoteSortBy } from '../../../state/selector';

export interface UseSortBySectionResult {
  noteSortBy: string;
  handleNoteSortByChange: (value: string) => void;
}

export const useSortBySection = (): UseSortBySectionResult => {
  const dispatch = useAppDispatch();
  const noteSortBy = useAppSelector(selectNoteSortBy);

  const handleNoteSortByChange = (value: string) => {
    dispatch(setNoteSortBy(value));
  };
  return { noteSortBy, handleNoteSortByChange };
};
